export function getDocumentDrivers(policyNumber) {
  return {
    type: 'GET_DOCUMENT_DRIVERS',
    meta: {
      offline: {
        effect: {
          method: 'GET',
          query: {
            mock: false,
            base: '/drivers/getDrivers',
            query: [
              {
                name: 'policyNumber',
                value: policyNumber,
              },
            ],
          },
        },
        commit: {
          type: 'GET_DOCUMENT_DRIVERS_COMMIT',
        },
        rollback: {
          type: 'GET_DOCUMENT_DRIVERS_ROLLBACK',
        },
      },
    },
  }
}

export function removeDocumentDriver(driverId, documentId, documentType) {
  return {
    type: 'REMOVE_DOCUMENT_DRIVER',
    payload: {
      driverId,
      documentId,
      documentType,
    },
    meta: {
      offline: {
        effect: {
          method: 'POST',
          query: {
            mock: false,
            base: '/drivers/removeDriver',
          },
        },
        commit: {
          type: 'REMOVE_DOCUMENT_DRIVER_COMMIT',
        },
        rollback: {
          type: 'REMOVE_DOCUMENT_DRIVER_ROLLBACK',
        },
      },
    },
  }
}

export function addDocumentDriver(driver) {
  return {
    type: 'ADD_DOCUMENT_DRIVER',
    payload: driver,
    meta: {
      offline: {
        effect: {
          method: 'POST',
          query: {
            mock: false,
            base: '/drivers/addDriver',
          },
        },
        commit: {
          type: 'ADD_DOCUMENT_DRIVER_COMMIT',
        },
        rollback: {
          type: 'ADD_DOCUMENT_DRIVER_ROLLBACK',
        },
      },
    },
  }
}

export function setDocumentDriver(driver) {
  return {
    type: 'SET_DOCUMENT_DRIVER',
    payload: { driver },
  }
}
